import React from 'react'
import PropTypes from 'prop-types'
import { Col, Form, FormGroup, Row } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import FormFooter from '../../../common/forms/FormFooter'
import { isRequired } from '../../../../utils/validators'
import FormItem from '../../../common/forms/FormItem'
import TextInput from '../../../common/forms/input/TextInput'

const LegalCargoSearchByDocumentNumberForm = ({ handleSubmit, loading }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Serie" required>
        <Field
          name="documentSerie"
          component={TextInput}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Correlativo" required>
        <Field
          name="documentCode"
          component={TextInput}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <Row>
      <Col className="text-right">
        <FormFooter
          saveButtonText="Buscar"
          saveButtonIcon="fa fa-search"
          saveButtonColor="primary"
          saveButtonDisabled={loading}
        />
      </Col>
    </Row>
  </Form>
)

LegalCargoSearchByDocumentNumberForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

LegalCargoSearchByDocumentNumberForm.defaultProps = {
  loading: false,
}

export default reduxForm({
  form: 'LegalCargoSearchByDocumentNumberForm'
})(LegalCargoSearchByDocumentNumberForm)

